import { Children, FC, ReactElement, cloneElement } from 'react'
import { ListCollapseToggleV2 } from '../ListCollapseToggle/ListCollapseToggleV2'

import Collapse from 'react-css-collapse'
import { observer } from 'mobx-react-lite'

interface Props {
  collapsed: boolean
  onToggle: () => void
  itemId: number | string
}

const List: FC<React.PropsWithChildren<Props>> = observer((props) => {
  const items = Children.toArray(props.children)
  const count = items.length
  const firstItem = cloneElement(items.shift() as ReactElement)
  const unreadCount = items.filter(
    (item) => cloneElement(item as ReactElement).props.comment?.read_status === false,
  ).length

  return (
    <div>
      {firstItem}
      <ListCollapseToggleV2
        collapsed={props.collapsed}
        count={count}
        unreadCount={unreadCount}
        onToggle={props.onToggle}
        itemId={props.itemId}
      />

      {items.length > 0 && (
        <Collapse isOpen={!props.collapsed}>
          {/* Empty element so that adding the Collapse component doesn't mess with Css's child selector logic */}
          <div />
          {items}
        </Collapse>
      )}
    </div>
  )
})

export { List }
